import PropTypes from 'prop-types'
import React from 'react'
import styles from './_friend.css'

export function Friend ({ friend, onHover, showDetails }) {
  const {
    id,
    location,
  } = friend

  const profile = `/profile/${id}`
  const profileImg = `${profile}/picture?size=Medium`

  let cityState = ''

  if (Object.keys(friend.location).length) {
    cityState = `${location.locality}, ${location.region}`
  }

  return (
    <div className={styles.container}>
      <a
        onMouseOver={() => onHover(id)}
        onMouseOut={() => onHover(null)}
        href={profile}>
        <img className={styles.thumb} src={profileImg} />
        {showDetails ?
          <div className={styles.detailsContainer}>
            <div className={styles.name}>{friend.display_name}</div>
            <div className={styles.city}>{cityState}</div>
            <img className={styles.thumbDetail} src={profileImg} />
          </div>
        : null}
      </a>
    </div>
  )
}

Friend.propTypes = {
  friend: PropTypes.object,
  onHover: PropTypes.func,
  showDetails: PropTypes.bool,
}

export default Friend



// WEBPACK FOOTER //
// ./src/components/home/friends/Friend.jsx